import { Injectable } from "@angular/core";
import { HttpService } from "../http.service";
import { Observable } from "rxjs";
import { NetworkOwner } from "../Models/NetworkOwner";
import { APIEndpoints } from "src/config/apiEndpoint.config";

@Injectable({
  providedIn: "root",
})
export class NetworkOwnerService {
  constructor(private httpService: HttpService) {}

  getNetworkOwners(): Observable<NetworkOwner[]> {
    return this.httpService.get<NetworkOwner[]>(
      APIEndpoints.getNetworkOwners,
      true
    );
  }
}
